module.exports = __webpack_public_path__ + "img/hyjmd2-img2.38302d2c.png";